module.exports = __webpack_public_path__ + "static/media/MHRM39N0021.c0702136.svg";